<template>
  <div>    
    <div class="row">
      <div class="col">       

        <iframe :src="telescopeUrl" width="100%" :height="height" ref="iframe"  frameborder="0" @load="load"></iframe>

      </div>
    </div>
  </div>
</template>

<script>



export default {
  
  

  methods: {
   load: function(){

    }
  },

  data() {
    return {
      height:5000,
      telescopeUrl:process.env.VUE_APP_API_PATH+"telescope",
    };
  }
};
</script>

<style>
</style>